// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1051":"c6319666","7666":"d8aadb74","8092":"db4359ad"}[chunkId] + ".chunk.css";
};